import VueCharts from "vue-chartjs";
import { Bar, Line } from "vue-chartjs";
import * as Annotation from "chartjs-plugin-annotation";

export default {
  extends: Bar,
  props: {
    averages: {},
    sds: {},
    universityAverage: {
      default: 0,
    },
    universityAverageLabel: {
      default: "ค่าเฉลี่ยมหาวิทยาลัย"
    },
    labels: {},
    yMax: {
      default: 20,
    },
    yAxisLabel: {
      default: 'คะแนนเฉลี่ย',
    }
  },

  mounted() {
    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            type: "bar",
            label: "ส่วนเบี่ยงเบนมาตรฐาน",
            backgroundColor: "#f0f0f0",
            data: this.sds,
          },
          {
            type: "bar",
            label: "ค่าเฉลี่ย",
            backgroundColor: "#bd9acf",
            data: this.averages,
          },
        ],
      },
      {
        title: {
          display: false,
        },
        elements: {
          point: {
            radius: 0,
          },
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                max: this.yMax,
              },
              scaleLabel: {
                display: true,
                labelString: this.yAxisLabel,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                min: 0,
                autoSkip: false,
                stepSize: 1,
              },
              stacked: true,
              maxBarThickness: 250,
              beginAtZero: true,
            },
          ],
        },
        annotation: {
          annotations: [
            {
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-0",
              value: this.universityAverage,
              borderColor: "#000",
              borderWidth: 1.5,
              label: {
                enabled: true,
                content: `${this.universityAverageLabel} ${this.universityAverage.toFixed(2)}`,
              },
            },
          ],
        },
        plugins: {
          datalabels: {
            color: "#000",
            rotation: 90,
            anchor: "center",
            offset: "bottom",
            clamp: true,
            font: {
              size: 11.5,
            },
            formatter: (value) => {
              return value;
            }
          },
        },
        legend: {
          display: true,
          defaultFontFamily: "Sarabun"
        },
        responsive: true,
        maintainAspectRatio: false,
      }
    );
  },
  watch: {},
};
